const LIVE_FEATURE_ENVS = ['dev', 'staging', 'production'];

export const isLiveFeatureEnabled = (env = process.env.NEXT_PUBLIC_ENV) =>
  LIVE_FEATURE_ENVS.includes(env ?? '');

export const LIVE_FEATURE_ENABLED = isLiveFeatureEnabled();
